"use strict";

/**********
Alert component
msg : String - Message to display
state: String - Specific class to style alert

Add a custom alert to DOM.
**********/
function Alert(msg, state) {
  this.timing = 4000;
  this.container = document.getElementById("js-alerts");
  this.sample = document.getElementById("js-alert");
  this.msg = msg;
  this.state = state;
  /*********
  CORE FUNCTIONS
  **********/

  /* Clone Alert sample from DOM, add text and msg depending on params and append alert to body. */

  this.add = function () {
    if (this.sample) {
      var that = this,
          el = this.sample.cloneNode(true),
          para = document.createElement("p");
      para.innerHTML = that.msg;
      el.removeAttribute('id');
      el.appendChild(para);
      el.classList.add('is-' + that.state);
      that.container.appendChild(el);
      that.show(el);
    }
  };
  /* el : Alert DOM element to target
  Add class to show alert and init hiding */


  this.show = function (el) {
    var that = this;
    setTimeout(function () {
      el.classList.add('is-visible');
      setTimeout(function () {
        that.hide(el);
      }, that.timing);
    }, 200);
  };
  /* el : Alert DOM element to target
  Remove class to hide alert and remove it from DOM */


  this.hide = function (el) {
    el.classList.remove('is-visible');
    setTimeout(function () {
      el.parentNode.removeChild(el);
      delete this;
    }, 200);
  };
  /*********
  CUSTOM UTILITIES
  ( To add alerts based on state needed ).
  **********/


  this.error = function (msg) {
    this.msg = msg ? msg : "Merci de remplir tous les champs nécessaires.";
    this.state = "danger";
    this.add();
  };

  this.warning = function (msg) {
    this.msg = msg ? msg : "Une erreur est survenu. Merci de réessayer ultérieurement.";
    this.state = "warning";
    this.add();
  };

  this.info = function (msg) {
    this.msg = msg ? msg : "Info";
    this.state = "info";
    this.add();
  };

  this.success = function (msg) {
    this.msg = msg ? msg : "Votre demande a bien été enregistrée";
    this.state = "success";
    this.add();
  };

  this.mail = function (msg) {
    this.msg = msg ? msg : "Un mail a bien été envoyé à notre équipe";
    this.state = "success";
    this.add();
  };

  this.mailPasswd = function (msg) {
    this.msg = msg ? msg : "Un mail vous a été envoyé afin de modifier votre mot de passe";
    this.state = "success";
    this.add();
  };
}